import { FC, memo } from 'react'
import { UnreadProjectItem } from './components/unreadProjectItem/unreadProjectItem'
import { useAppSelector } from 'states/hooks'
import {
  useSelectSortedUnreadActiveChatRooms,
  useUserSetting,
} from '@crew/states'
import { FavoriteDisplayOrderTypeValues, SettingKeyType } from '@crew/enums/app'
import { FavoriteDisplayOrderType } from '@crew/enums/domain'
import { getEnumDataByValue } from '@crew/utils/enum'

// アコーディオン内に表示されるアイテム表示
export const UnreadProjectList: FC = memo(() => {
  // 個人設定のお気に入り表示順設定
  const favoriteDisplayOrderType = useUserSetting(
    SettingKeyType.FavoriteDisplayOrderType,
    FavoriteDisplayOrderType.Activity
  )

  // 表示順に応じてソートした未読チャットルームを取得する
  const selectSortedUnreadChatRooms = useSelectSortedUnreadActiveChatRooms()
  const sortedUnreadChatRooms = useAppSelector((state) => {
    // お気に入り表示順が取得できていない場合は何も表示しない
    if (!favoriteDisplayOrderType) {
      return []
    }
    const sortType = getEnumDataByValue(
      FavoriteDisplayOrderTypeValues,
      favoriteDisplayOrderType
    )
    // 通常はありえないが、お気に入り表示順の値がenumに存在しない場合は何も表示しない
    if (!sortType) {
      return []
    }
    return selectSortedUnreadChatRooms(state, sortType.value)
  })

  return (
    <ul className="flex-1">
      {sortedUnreadChatRooms.map((chatRoom) => {
        return (
          <UnreadProjectItem key={chatRoom.chatRoomId} chatRoom={chatRoom} />
        )
      })}
    </ul>
  )
})
